import React from 'react';
import memoize from 'memoize-one';
import { ButtonTooltip, Icon } from '../../../components';

const getDocumentName = item =>
  item?.document_type != null ? item?.translated_document_type || '-' : item?.name || '-';

export default memoize(clickHandler => [
  {
    name: 'NOMBRE DEL DOCUMENTO',
    selector: 'name',
    cell: getDocumentName,
    grow: 2,
    sortable: true,
    wrap: true
  },
  {
    name: 'ACCIONES',
    cell: item => {
      const hasFile = !!item?.document_info?.file_url;
      return (
        <>
          <ButtonTooltip
            variant="circle-info"
            className="btn-circle me-1"
            size="sm"
            text="Ver"
            disabled={!hasFile}
            onClick={() => hasFile && clickHandler(item, 'show')}
          >
            <Icon icon="eye" />
          </ButtonTooltip>

          <ButtonTooltip
            variant="circle-primary"
            className="btn-circle"
            size="sm"
            text="Descargar"
            disabled={!hasFile}
            onClick={() => hasFile && clickHandler(item, 'download')}
          >
            <Icon icon="download-2" />
          </ButtonTooltip>
        </>
      );
    },
    ignoreRowClick: true,
    allowOverflow: false,
    center: true,
    button: true,
    grow: '1',
    minWidth: '300px'
  }
]);
